<template>
<div class="chapter">
<div class="inner_page">
<div class="ipadfp"><img alt="Born on a Rotten Day: Illuminating and Coping with the Dark Side of the Zodiac, by Hazel Dixon-Cooper. Atria." class="imagefp" src="images/titlea.png"/></div>
<div class="ipadfp"><a id="title"><img alt="Image" class="imagefp" src="images/title.jpg"/></a></div><a id="title">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?220bb1b3